export default __webpack_public_path__ + "static/media/info-circle.af4baa3a.svg";